import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../App.css';
import { loadCss } from 'esri-loader';
import Nav from '../../components/Nav2';
import Map2 from '../../components/Map2';
import Dashboard2 from '../../components/Dashboard2';
import GageClickModal from '../../components/GageClickModal';

class Private extends Component {

    constructor(props) {
        super(props)

        this.state = {
            center: [-79.9414, 37.2710],
            buildingMarker: null,
            gageName: null,
            usgsGageID: null,
            noaaGageID: null,
            zoom: 13,
            gageDatum: null,
            inundationLevel: null,
            inundationVisibility: false,
            buildingLevel: null,
            buildingVisibility: false,
            dashboardView: null,
            sliderVisibility: "none",
            currentElevation: null,
            currentStage: null,
            scenarioSliderValue: null,
            forecastSliderValue: null,
            forecastStageValue: null,
            forecastDateReading: null,
            refreshData: null
        }
        this.setCenterAndZoom = this.setCenterAndZoom.bind(this);
    }


    
    componentDidMount() {
        // get esrii default css
        loadCss();

    }

    setCenterAndZoom = (center, zoom) => {
        this.setState({ center, zoom });
    }

    setBuildingMarker = (buildingMarker) => {
        this.setState({ buildingMarker })
    }

    setUSGSGageID = (GageID) => {
        this.setState({ usgsGageID: GageID });
    }

    setNOAAGageID = (noaaGageID) => {
        this.setState({ noaaGageID });

    }

    setGageName = (gageName) => {
        this.setState({ gageName });
    }

    setGageDatum = (gageDatum) => {
        this.setState({ gageDatum })
    }

    setDashboardAndSlider = (dashboardView) => {
        if (this.state.usgsGageID === "02055000" && (dashboardView !==  null)) {

            if (dashboardView === "scenario" && document.getElementById("sliderScenarioDiv")) {
                document.getElementById("sliderForecastDiv").style.display = "none";
                document.getElementById("sliderScenarioDiv").style.display = "flex";
                this.setState({ dashboardView: dashboardView, sliderVisibility: "flex" });
            } else if (dashboardView === "forecast" && document.getElementById("sliderForecastDiv")) {
                document.getElementById("sliderScenarioDiv").style.display = "none";
                document.getElementById("sliderForecastDiv").style.display = "flex";
                this.setState({ dashboardView: dashboardView, sliderVisibility: "none" });
            } else if (dashboardView === "current") {
                document.getElementById("sliderScenarioDiv").style.display = "none";
                document.getElementById("sliderForecastDiv").style.display = "none";
                this.setState({ dashboardView: dashboardView, sliderVisibility: "flex" });
            }
        } else {
            this.setState({ dashboardView: dashboardView, sliderVisibility: "none" });
            document.getElementById("sliderScenarioDiv").style.display = "none";
            document.getElementById("sliderForecastDiv").style.display = "none";

        }

    }


    setScenarioSliderValue = (scenarioSliderValue) => {
        this.setState({ scenarioSliderValue });
    }

    setCurrentElevation = (currentElevation) => {
        this.setState({ currentElevation })
    }

    setCurrentStage = (currentStage) => {
        this.setState({ currentStage });
    }

    setForecastSliderValue = (forecastSliderValue) => {
        this.setState({ forecastSliderValue });
    }

    setForecastStageValueAndDateReading = (forecastStageValue, forecastDateReading) => {
        this.setState({ forecastStageValue, forecastDateReading });
    }
 
    //not working yet
    setInundationLevelAndVisibility = (inundationLevel, inundationVisibility) => {
        this.setState({ inundationLevel, inundationVisibility });
    }

    setBuildingLevelAndVisibility = (buildingLevel, buildingVisibility) => {
        this.setState({ buildingLevel, buildingVisibility });
    }

    setRefreshData = (refreshData) => {        
        this.setState({ refreshData });
    }


    render() {

        return (
            <div style={{ width: '100vw', height: '100vh' }}>
                <Nav
                    setDashboardAndSlider={this.setDashboardAndSlider}
                    dashboardView={this.state.dashboardView}
                />
                <Map2
                    setZoom={this.setZoom}
                    setUSGSGageID={this.setUSGSGageID}
                    setGageName={this.setGageName}
                    setGageDatum={this.setGageDatum}
                    setNOAAGageID={this.setNOAAGageID}
                    setCenterAndZoom={this.setCenterAndZoom}
                    setBuildingMarker={this.setBuildingMarker}
                    buildingMarker={this.state.buildingMarker}
                    usgsGageID={this.state.usgsGageID}
                    noaaGageID={this.state.noaaGageID}
                    center={this.state.center}
                    zoom={this.state.zoom}
                    testIundationLevel={this.state.testIundationLevel}
                    inundationLevel={this.state.inundationLevel}
                    inundationVisibility={this.state.inundationVisibility}
                    setInundationLevelAndVisibility={this.setInundationLevelAndVisibility}
                    setBuildingLevelAndVisibility={this.setBuildingLevelAndVisibility}
                    sliderVisibility={this.state.sliderVisibility}
                    setDashboardAndSlider={this.setDashboardAndSlider}
                    setScenarioSliderValue={this.setScenarioSliderValue}
                    setCurrentElevation={this.setCurrentElevation}
                    setCurrentStage={this.setCurrentStage}
                    setForecastSliderValue={this.setForecastSliderValue}
                    setForecastStageValueAndDateReading={this.setForecastStageValueAndDateReading}
                    dashboardView={this.state.dashboardView}
                    currentElevation={this.state.currentElevation}
                    currentStage={this.state.currentStage}
                    forecastSliderValue={this.state.forecastSliderValue}
                    scenarioSliderValue={this.state.scenarioSliderValue}
                    refreshData={this.state.refreshData}
                />
                <Dashboard2
                    usgsGageID={this.state.usgsGageID}
                    noaaGageID={this.state.noaaGageID}
                    gageDatum={this.state.gageDatum}
                    gageName={this.state.gageName}
                    setCenterAndZoom={this.setCenterAndZoom}
                    setBuildingMarker={this.setBuildingMarker}
                    dashboardView={this.state.dashboardView}
                    scenarioSliderValue={this.state.scenarioSliderValue}
                    setScenarioSliderValue={this.setScenarioSliderValue}
                    currentElevation={this.state.currentElevation}
                    setCurrentElevation={this.setCurrentElevation}
                    setCurrentStage={this.setCurrentStage}
                    forecastSliderValue={this.state.forecastSliderValue}
                    forecastStageValue={this.state.forecastStageValue}
                    forecastDateReading={this.state.forecastDateReading}
                    setForecastSliderValue={this.setForecastSliderValue}
                    setForecastStageValueAndDateReading={this.setForecastStageValueAndDateReading}
                    refreshData={this.state.refreshData}
                    setRefreshData={this.setRefreshData}
                />
                <GageClickModal showGageModal={sessionStorage.getItem('firstVisit') ? false : true}/>
            </div>
        );

    }
}

export default Private;


// WEBPACK FOOTER //
// ./src/pages/Private2/index.js